import AddIcons from '@/icons/AddIcons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy, Button } from 'vnetwork-ui'

interface CCCDImage {
    file: File | null
    preview: string | null
    attachment_url?: string
}

interface ImageUploadCardProps {
    type: 'front' | 'back'
    image: CCCDImage
    onSelect: () => void
    onCapture?: () => void
    percent?: Record<string, number>
}

const ImageUploadCard: React.FC<ImageUploadCardProps> = ({
    type,
    image,
    onSelect,
    onCapture,
    percent = {},
}) => {
    const { t } = useTranslation()

    return (
        <div className="border-2 border-dashed border-gray-300 rounded-md p-4 text-center  transition-colors hover:border-blue-500">
            {image?.preview ? (
                <div className="space-y-4 cursor-pointer" onClick={onSelect}>
                    <img
                        src={image?.preview}
                        alt={`CCCD ${type}`}
                        className="max-w-full h-48 object-contain mx-auto rounded-lg"
                    />
                    {percent[image?.file?.name || ''] && (
                        <div className="w-full bg-gray-200 rounded-full h-2">
                            <div
                                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                                style={{
                                    width: `${percent[image?.file?.name || '']}%`,
                                }}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <div className="space-y-4">
                    <div
                        className="w-16 h-16 mx-auto bg-gray-200 rounded-lg flex items-center justify-center cursor-pointer"
                        onClick={onSelect}
                    >
                        <AddIcons className="w-6 h-6 text-gray-400" />
                    </div>
                    <div>
                        <Typogaphy
                            size="small"
                            className="text-gray-600 mb-2 text-[12px]"
                        >
                            {type === 'front'
                                ? t('cccd-front-side')
                                : t('cccd-back-side')}
                        </Typogaphy>
                    </div>
                    <div className="flex gap-2 justify-center">
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={onSelect}
                            className="text-xs px-3 py-1"
                        >
                            {t('choose-file')}
                        </Button>
                        {onCapture && (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={onCapture}
                                className="text-xs px-3 py-1"
                            >
                                📷 {t('take-photo')}
                            </Button>
                        )}
                    </div>
                    <Typogaphy
                        size="small"
                        className="text-gray-500 text-[10px]"
                    >
                        {t('supported-formats')}: JPG, PNG, GIF (Max 10MB)
                    </Typogaphy>
                </div>
            )}
        </div>
    )
}

export default ImageUploadCard
export type { CCCDImage }
